import $ from 'jquery';
import 'lightgallery';
import 'lightgallery/modules/lg-thumbnail';

class GalleryWithPreview {
	constructor(params = {}) {
		/**
		 * @type {!Object}
		 * @private
		 */
		this.params 		 = params;

		/**
		 * @type {!JQuery}
		 * @private
		 */
		this.galleryElements = this.params.galleryElements || $('.galleryWithPreview');

		/**
		 * @type {string}
		 * @private
		 */
		this.imagesSelector = this.params.imagesSelector || '.galleryWithPreviewItem img';

		this.init();
	}

	init() {
		this.galleryElements
			// stop errors when clicking on the elements container's border
		    .on('click', (ev) => ev.stopImmediatePropagation())
			.lightGallery({
				'animateThumb'        : true,
				'pager'               : true,
				'download'            : false,
				'supportLegacyBrowser': false
			});

		if (!this.params.galleryElements) {
			this.galleryElements.one('onBeforeOpen.lg', () => {
				/*
					this loads the remaining thumbnail images for the gallery which weren't loaded before
					LightGallery would mess it up otherways
				 */
				this.galleryElements
					.find(this.imagesSelector)
					.each((i, image) => {
						if (!image.getAttribute('src')) {
							image.setAttribute('src', image.dataset.src);
						}
					});
			});
		}
	}
}

export default GalleryWithPreview;